<template>
  <vs-prompt buttons-hidden :title="`Edit ${editDykLocalization ? editDykLocalization.product_name : ''} Localizations`" :active="editDykLocalization.show" @close="close">
    <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>

    <div class="vx-row mb-1" style="max-height: 550px; overflow-y: scroll;">
      <div class="vx-col  w-full">
        <template
          v-for="(localization, index) in workingLocalizations" :index="index">
          <vs-textarea
            class="w-full py-2 my-2"
            :key="localization.language_id"
            :label="getLanguageNameAndCode(localization.language_id)"
            v-model="localization.dyk_description"
          />
        </template>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full mb-2">
        <vs-button class="mx-1 w-full" @click="saveDykLocalizations" >Save Changes</vs-button>
      </div>
    </div>
  </vs-prompt>
</template>

<script>

import api from "@/http/api";

export default {
  props:['editDykLocalization'],
  data() {
    return {
      loading: false,
      workingLocalizations: [],
      languages: null
    }
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    editDykLocalization: function(val) {
      this.workingLocalizations = val.localizations;
    }
  },
  methods: {
    async fetchData() {
      this.languages = await api.fetchAllLanguages();
    },
    async saveDykLocalizations() {
      this.loading = true;
      let results = [];

      this.workingLocalizations.forEach((localization) => {
        results.push(api.saveProductLocalization(localization));
      })
      await Promise.all(results);
      this.$vs.notify({
        position: 'top-center',
        color:'primary',
        title:'',
        text:'Saved Successfully!'
      })

      this.loading = false;
    },
    getLanguageNameAndCode(id) {
      try {
        const lang = this.languages.filter((l) => l.language_id === id)[0];
        return `${lang.name} (${lang.code}-${lang.country || ''})`;
      } catch (e) {
        return '?';
      }
    },
    close() {
      this.$emit('update:editDykLocalization', {show: false, product_name: '', localizations: []});
    },
  }
}
</script>
